<template lang="html">
  <el-card shadow="always" body-style="padding:0px;width:100%;">
    <div :id="params.id" :style="params.chartHeight"></div>
    <div :id="params.id + '_table'" class="echart_table">
      <div style="width: 100%; height: 34px; line-height: 34px">
        <div style="width: 60px; float: left; text-align: center">
          <i @click="downloadData(params.id)" class="fa fa-download searchFilerCls" aria-hidden="true" title="导出"></i>
        </div>
        <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
          <el-col
            v-for="(key, index) in Object.keys(params.columnMap[params.id])"
            :key="key"
            :span="Object.keys(params.columnMap[params.id]).length <= 4 ? 6 : 4">
            <el-input
              v-model="queryFilter[key]"
              clearable
              size="mini"
              :placeholder="'请输入' + params.columnMap[params.id][key]"
              style="margin-top: 0px; margin-bottom: 3px"
              class="searchInput">
              <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <table
        :id="params.id + '_tab'"
        style="width: 100%"
        class="tabletemp table-striped table-bordered tabletemp-hover">
        <thead>
          <tr>
            <th>
              <div title="返回" class="th-inner" style="text-align: center" @click="backEcharts(params.id)">
                <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
              </div>
              <div class="fht-cell"></div>
            </th>
            <th v-for="(key, index) in Object.keys(params.columnMap[params.id])" :key="key" nowrap="nowrap">
              <div class="th-inner text-warning">
                {{ params.columnMap[params.id][key] }}
                <i
                  @click="sortData(params.id, key, querySort[params.id][key])"
                  :class="
                    querySort[params.id][key] == 'sort'
                      ? 'fa fa-sort'
                      : querySort[params.id][key] == 'asc'
                      ? 'fa fa-sort-asc'
                      : querySort[params.id][key] == 'desc'
                      ? 'fa fa-sort-desc'
                      : ''
                  "
                  :style="querySort[params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''"></i>
              </div>
              <div class="fht-cell">
                <el-input
                  v-if="queryVisible[params.id]"
                  v-model="queryFilter[key]"
                  clearable
                  size="mini"
                  placeholder="请输入内容"
                  class="searchInput">
                  <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </th>
          </tr>
        </thead>
        <tbody :id="params.id + '_html'" style="font-size: 14px !important">
          <tr>
            <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";
import chartFinance from "@/components/ChartFinance/StatisticalFinance.vue";
import provinceFinance from "@/components/ChartFinance/ProvinceFinance.vue";

import { getChartData2, listData } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  props: [
    "params",
    "searchData",
    "queryFilter",
    "queryVisible",
    "querySort",
    "sortData",
    "downloadData",
    "chartResize",
    "backEcharts",
    "setDisplayVisible",
    "createDataHtml",
    "setQueryVisible",
    "listTableData",
  ],
  data() {
    return {};
  },
  methods: {
    //柱图 组
    chart_4(id, data) {
      let that = this;
      this.disposeChart(id);
      let barNums = [];
      let names = [];
      if (id == "chart_51") {
        var narr = ["注册资本", "资产", "负债"];
        for (var s = 0; s < 3; s++) {
          var arr = [];
          for (var i in data.data) {
            let item = data.data[i];
            if (s == 0) {
              arr.push(item.value);
              names.push(item.name);
            } else {
              arr.push(item["value" + (s + 1)]);
            }
          }
          barNums.push({ type: "bar", name: narr[s], data: arr });
        }
      }
      if (id == "chart_52") {
        var narr = ["<0", "0", "0-0.5", "0.5-1", "1-5", "5-10", "10-20", ">20"];
        var json = {};
        //console.log("====", data);
        for (var s = 0; s < 8; s++) {
          var list = data.data[s];
          for (var i in list) {
            let item = list[i];
            if (!json[s]) {
              json[s] = [];
            }
            json[s].push(item.value);
            if (s == 0) names.push(item.name);
          }
        }
        //console.log("====", json);
        for (var key in json) {
          barNums.push({ type: "bar", name: narr[key], data: json[key] });
        }
      }
      if (id == "chart_182" || id == "chart_282") {
        var narr = ["实（载）体出版", "利用信息网络出版", "总计"];
        var json = {};
        //console.log("AA====", data);
        var d1 = data.data["szt"].list;
        var d2 = data.data["wlcb"].list;
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        for (var i in d1) {
          let item = d1[i];
          let item2 = d2[i];
          arr1.push(item.value);
          arr2.push(item2.value);
          arr3.push(Number(item.value) + Number(item2.value));
          names.push(item.name);
        }
        //console.log("====", arr1);
        //console.log("====", arr2);
        barNums.push({ type: "line", name: narr[0], data: arr1 });
        barNums.push({ type: "line", name: narr[1], data: arr2 });
        barNums.push({ type: "line", name: narr[2], data: arr3 });
      }
      if (id == "chart_183" || id == "chart_283") {
        var narr = ["实（载）体出版", "利用信息网络出版", "总计"];
        var json = {};
        //console.log("AA====", data);
        var d1 = data.data;
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        for (var i in d1) {
          let item = d1[i];
          if (i % 2 == 0) {
            arr1.push(item.value);
            names.push(item.year);
          }
          if (i % 2 == 1) {
            arr2.push(item.value);
          }
        }
        for (var i in arr1) {
          arr3.push(Number(arr1[i]) + Number(arr2[i]));
        }
        barNums.push({ type: "line", name: narr[0], data: arr1 });
        barNums.push({ type: "line", name: narr[1], data: arr2 });
        barNums.push({ type: "line", name: narr[2], data: arr3 });
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: data.subtext,
          left: "center",
          top: 30,
        },
        grid: {
          top: 80,
          bottom: 100,
          left: 80,
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function (option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, myChart, option1);
              },
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function (option1) {
                that.listTableData(id, null, option);
              },
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 30,
        },
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: names,
          axisLabel: {
            interval: 0,
            rotate: 15,
          },
        },
        yAxis: {},
        dataset: { source: data.data },
        series: barNums,
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
  },
  mounted() {
    this.chart_4(this.params.id, this.params.data[this.params.id] || []);
  },
  created: function () {},
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;
}
.echart_table {
  height: 420px;
  width: 100%;
  overflow: hidden;
  display: none;
}
.el-checkbox + .el-checkbox {
  margin-left: 15px;
}
.el-checkbox__label {
  padding-left: 4px !important;
}

.searchInput {
  margin-top: 6px;
}

.searchInputN {
  margin-top: 6px;
}

.searchFilerCls {
  color: #ff9800 !important;
}

.searchFilerClsN {
  float: right;
  padding-top: 3px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// MBarChart.vue?0f4f0c89